export const FETCH_CLAIMS_REQUEST = 'FETCH_CLAIMS_REQUEST';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const FETCH_CLAIMS_FAILURE = 'FETCH_CLAIMS_FAILURE';

export const SAVE_CLAIM_REQUEST = 'SAVE_CLAIM_REQUEST';
export const SAVE_CLAIM_SUCCESS = 'SAVE_CLAIM_SUCCESS';
export const SAVE_CLAIM_FAILURE = 'SAVE_CLAIM_FAILURE';

export const CHANGE_CLAIM_STATUS_REQUEST = 'CHANGE_CLAIM_STATUS_REQUEST';
export const CHANGE_CLAIM_STATUS_SUCCESS = 'CHANGE_CLAIM_STATUS_SUCCESS';
export const CHANGE_CLAIM_STATUS_FAILURE = 'CHANGE_CLAIM_STATUS_FAILURE';

export const FETCH_CLAIM_APPROVALS_REQUEST = 'FETCH_CLAIM_APPROVALS_REQUEST';
export const FETCH_CLAIM_APPROVALS_SUCCESS = 'FETCH_CLAIM_APPROVALS_SUCCESS';
export const FETCH_CLAIM_APPROVALS_FAILURE = 'FETCH_CLAIM_APPROVALS_FAILURE';

export const SAVE_CLAIM_APPROVAL_REQUEST = 'SAVE_CLAIM_APPROVAL_REQUEST';
export const SAVE_CLAIM_APPROVAL_SUCCESS = 'SAVE_CLAIM_APPROVAL_SUCCESS';
export const SAVE_CLAIM_APPROVAL_FAILURE = 'SAVE_CLAIM_APPROVAL_FAILURE';

export const CHANGE_CLAIM_APPROVAL_STATUS_REQUEST = 'CHANGE_CLAIM_APPROVAL_STATUS_REQUEST';
export const CHANGE_CLAIM_APPROVAL_STATUS_SUCCESS = 'CHANGE_CLAIM_APPROVAL_STATUS_SUCCESS';
export const CHANGE_CLAIM_APPROVAL_STATUS_FAILURE = 'CHANGE_CLAIM_APPROVAL_STATUS_FAILURE';

export const FETCH_VIEW_CLAIM_LIST_REQUEST = 'FETCH_VIEW_CLAIM_LIST_REQUEST';
export const FETCH_VIEW_CLAIM_LIST_SUCCESS = 'FETCH_VIEW_CLAIM_LIST_SUCCESS';
export const FETCH_VIEW_CLAIM_LIST_FAILURE = 'FETCH_VIEW_CLAIM_LIST_FAILURE';

export const SEND_CLAIM_APPROVAL_REQUEST = 'SEND_CLAIM_APPROVAL_REQUEST';
export const SEND_CLAIM_APPROVAL_SUCCESS = 'SEND_CLAIM_APPROVAL_SUCCESS';
export const SEND_CLAIM_APPROVAL_FAILURE = 'SEND_CLAIM_APPROVAL_FAILURE';

